// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2YXIS","obliqueLineWrap":"membershipbadge_obliqueLineWrap__VHzJl","obliqueLine":"membershipbadge_obliqueLine__2UAUM"};